class Person {
    constructor(name, birthYear, eyeColor, gender, hairColor, height, mass, skinColor, homeworld, films, species, starships, vehicles, url) {
      this.name = name;
      this.birthYear = birthYear;
      this.eyeColor = eyeColor;
      this.gender = gender;
      this.hairColor = hairColor;
      this.height = height;
      this.mass = mass;
      this.skinColor = skinColor;
      this.homeworld = homeworld;
      this.films = films;
      this.species = species;
      this.starships = starships;
      this.vehicles = vehicles;
      this.url = url;
    }
  }
  
  export default Person;